import { KeyboardEvent, useEffect, useState } from 'react';
import { isSaveShortcut } from '../../../helpers/saveShortcutHelper';

/**
 * Number and date fields commit what was typed when they lose focus, so the shortcut first
 * takes focus off the field and saves on the next render, once those commits have landed.
 * Saving in the same breath would send the values from before the last edit. A held key
 * repeats, so only its first press saves — the repeats are still kept from typing a line break.
 */
export const useSaveShortcut = (onSave: () => void, disabled: boolean) => {
  const [saveRequested, setSaveRequested] = useState(false);

  useEffect(() => {
    if (!saveRequested) return;
    setSaveRequested(false);
    onSave();
  }, [saveRequested]);

  return (event: KeyboardEvent<HTMLElement>) => {
    if (!isSaveShortcut(event)) return;
    event.preventDefault();
    event.stopPropagation();
    if (disabled || event.repeat) return;
    if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
    setSaveRequested(true);
  };
};
